let helper = new Object()

helper.getWordEndingByCount = (count, wordByEdinstvenii, wordByRoditelskii, wordByImenitelnii) => {
  const edinstvenii = 1
  const iskl = [0, 11, 12, 13, 14, 15, 16, 17, 18, 19]
  const roditelskii = [9, 8, 7, 6, 5, 0]
  const imenitelnii = [4, 3, 2]
  if (!count) return ''
  else if (iskl.includes(count)) return wordByRoditelskii
  else if (count == edinstvenii || count % 10 == edinstvenii) return wordByEdinstvenii
  else if (roditelskii.filter(num => count % 10 == num).length > 0) return wordByRoditelskii
  else if (imenitelnii.filter(num => count % 10 == num).length > 0) return wordByImenitelnii
  return ''
}

export default helper
